import { render, staticRenderFns } from "./Lgx243089970070290432.vue?vue&type=template&id=10c96a82&scoped=true&"
import script from "./Lgx243089970070290432.vue?vue&type=script&lang=js&"
export * from "./Lgx243089970070290432.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243089970070290432.vue?vue&type=style&index=0&id=10c96a82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c96a82",
  null
  
)

export default component.exports